var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJaDevelopmentLogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 965.16 963.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M766.76,603.02v.06s.07-.04.1-.06h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.76,443.22c-39.9-179.4-229.9-278.2-398.6-204.4-121,52.9-191.5,183.5-169.1,312.9,13.2,76.4,51.9,137.8,113.9,184,61.8,46.2,131.8,63.5,208.3,54.5,18.1-2.2,36-6,53.5-12.5v-174.64c-2.14,1.26-3.62,1.96-4.8,2.84-13.6,10-28.8,16.6-44.7,21.8-52.9,17.2-110.2-.5-144.2-44.5-24.4-31.7-31.3-67.4-25.1-106.6,9.1-58,54.7-104.7,111-114,59.7-9.9,118.3,20.6,144.6,73.6,10.4,21.1,14.3,43.5,14.3,66.8.1,71.7-.1,143.3.4,215,.3,34.5,24.9,62.9,59,69.9,33.3,6.9,67.3-10.9,81.5-42.1,5.3-11.6,6.4-23.7,6.4-36.1v-207c0-20.1-2-39.9-6.4-59.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.46,531.82v-229.9c0-4.3,0-8.7-.2-13-2-41.2-35.8-73.7-77.1-74.1-43.8-.5-79.8,35.2-80.4,79.9,0,.69-.01,1.23-.02,1.65.01,11.18.02,28.99.02,56.35,0,134.2-.3,268.5.3,402.8.1,31.6-25.8,48.9-46.9,49.3-48.4.9-83,41.2-77.6,89.4,4.1,36.2,35.6,66.9,72.1,68.8,46.9,2.4,89.9-10.5,127.2-39,54.3-41.4,82.1-96.9,82.6-165.3.5-75.6.1-151.3.1-226.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.74,296.37c-.04-41.68-.13,8.85,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.66.02c-46.4-1.1-85.6,39.6-85.4,83.8.2,46.9,36,84.9,81.4,85.1,46.9.3,85.7-38,85.7-84.6v-.1C288.46,36.42,253.36,1.22,206.66.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaDevelopmentLogoSvg);
export default __webpack_public_path__ + "static/media/jaDevelopmentLogoSVG.9c30087c58df39b296b534aac5828279.svg";
export { ForwardRef as ReactComponent };